"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpAlert = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const alert_html_1 = __importDefault(require("./alert.html"));
let ItpAlert = class ItpAlert extends vue_property_decorator_1.Vue {
    id;
    type;
    message;
    dismissible;
    show;
    onDismissed() {
        this.$emit('dismissed', { id: this.id });
    }
};
exports.ItpAlert = ItpAlert;
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpAlert.prototype, "id", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'info' }),
    __metadata("design:type", String)
], ItpAlert.prototype, "type", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpAlert.prototype, "message", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpAlert.prototype, "dismissible", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpAlert.prototype, "show", void 0);
exports.ItpAlert = ItpAlert = __decorate([
    (0, vue_property_decorator_1.Component)({ template: alert_html_1.default })
], ItpAlert);
//# sourceMappingURL=alert.js.map